import React from 'react';
function Search (props) {
    const { searched, handleSearch, clearSearch} = props
    
        return (
            <fieldset>
                <legend className="search-title">Wyszukaj</legend>
                <hr />
                <div className="form-group">
                    <div className="chosen-container-single">
                        <div className="chosen-search">
                            <input type="text" className="form-control" id="searchInput" placeholder="podaj miejscowość lub ID lub frazę" value={searched} onChange={handleSearch}/>
                            <div className="btn btn-link" onClick={clearSearch}>wyczyść</div>
                            <div className="help-block text-wrap">Wyszukiwanie przy uwzględnieniu poniższego filtru</div>
                        </div>
                    </div>
                </div>
        </fieldset>
        )
}

export default Search;